((NewsletterPopout, $) => {

  const $dom = {};
  var autoExpandTimer;

  const cacheDom = () => {
    $dom.popout = $('.newsletter-popout');
    $dom.btn = $('.newsletter-popout__btn');
    $dom.exit = $('.newsletter-popout__body-exit');
    $dom.form = $('.newsletter-popout__form');
    $dom.msg = $('.newsletter-popout__content-message');
  };

  const togglePopout = () => {
    $dom.popout.toggleClass('is-active');
    clearTimeout(autoExpandTimer);
  };

  const initTab = () => {
    if (Cookies.get('bva_newsletter_popout') == undefined) {
      $dom.popout.removeClass('is-hidden');
      if ($dom.popout.attr('data-auto-expand')) {
        startTimer();
      }
    }
  };

  const startTimer = () => {
    const timeToWait = $dom.popout.attr('data-auto-expand') * 1000;
    autoExpandTimer = setTimeout(function() {
      togglePopout();
    }, timeToWait);
  };

  const endTimer = () => {
    clearTimeout(autoExpandTimer);
  }

  const submitForm = () => {
    $.ajax({
      type: $dom.form.attr('method'),
      url: $dom.form.attr('action'),
      data: $dom.form.serialize(),
      cache: false,
      dataType: 'json',
      contentType: 'application/json; charset=utf-8'
    }).fail(function() {
      alert('Could not connect to signup. Please try again later.');
    }).done(function(data) {
      if (data.result != 'success') {
        $dom.msg.html(data.msg).removeClass('is-success').addClass('is-error').find('a').attr('target', '_blank');
        Cookies.set('bva_newsletter_popout', true, { expires: 7 });
      } else {
        $dom.msg.html(data.msg).removeClass('is-error').addClass('is-success');
      }
    });
  };

  const bindUIActions = function () {
    $dom.btn.click(function() {
      togglePopout();
    });

    $dom.exit.click(function() {
      togglePopout();
      $dom.popout.addClass('is-hidden');
      Cookies.set('bva_newsletter_popout', true, { expires: 7 });
    });

    $dom.form.submit(function(e) {
      e.preventDefault();
      submitForm();
    });
  };

  NewsletterPopout.init = function () {
    cacheDom();
    initTab();
    bindUIActions();
  };

})(window.NewsletterPopout = window.NewsletterPopout || {}, jQuery);